import React from 'react'
import { Table, Button, OverlayTrigger, Tooltip } from 'react-bootstrap'
import '../../screens/ReportHistory/ReportHistory.css'
import '../../components/kyc/kycStyle.css'
import '../../components/kyc/SearchResultsTable.css'
interface Report {
  reference: string
  name: string
  reportType: string
  requestedAt: string
  id: string
  reportTypeDescription: string
  reportTypeId: number
  reportIdNumber: string
  isActive: boolean
}

interface Props {
  currentRecords: Report[]
  handleDownloadReport: (report: Report) => void
}
const add72Hours = (datetimeStr: string | number | Date) => {
  const datetime = new Date(datetimeStr)
  const newDatetime = new Date(datetime.getTime() + 72 * 60 * 60 * 1000)
  return newDatetime.toISOString().slice(0, 19).replace('T', ' ')
}
const formatDate = (dateString: string) => {
  return dateString.slice(0, 19).replace('T', ' ')
}
const HistoryTable: React.FC<Props> = ({
  currentRecords,
  handleDownloadReport,
}) => {
  return (
    <div className="kyc-results-table-container">
      <table>
        <thead>
          <tr>
            <td className="headerStyles">Reference</td>
            <td className="headerStyles">Search Term</td>
            <td className="headerStyles">Type</td>
            <td className="headerStyles">Date Requested</td>
            <td className="headerStyles">Download</td>
          </tr>
        </thead>
        <tbody>
          {currentRecords.map((report) => {
            return (
              <tr key={report.id}>
                <td>{report.reference}</td>
                <td>{report.reportIdNumber}</td>
                <td>{report.reportTypeDescription}</td>
                <td>{formatDate(report.requestedAt)}</td>
                <td>
                  {!report.isActive ? (
                    <>
                      <OverlayTrigger
                        trigger="hover"
                        placement="top"
                        overlay={
                          <Tooltip className="custom-tooltip">
                            Expired {add72Hours(report.requestedAt)}. As
                            required by the NCR reports are only available for
                            72 hours from the time of request. Please
                            re-download the report.
                          </Tooltip>
                        }
                      >
                        <span>
                          <Button
                            disabled={!report.isActive}
                            className="btn-lg btn-kyc"
                            onClick={() =>
                              alert('Can not download expired report!')
                            }
                          >
                            Download
                          </Button>
                        </span>
                      </OverlayTrigger>
                    </>
                  ) : (
                    <Button
                      disabled={!report.isActive}
                      className="btn-lg btn-kyc"
                      onClick={() => handleDownloadReport(report)}
                    >
                      Download
                    </Button>
                  )}
                </td>
              </tr>
            )
          })}
        </tbody>
      </table>
    </div>
  )
}

export default HistoryTable
